import { Pipe, PipeTransform } from '@angular/core';

import { verifyPhoneNumber } from '../constants/constants';

@Pipe({ name: 'verifyPhoneNumber', standalone: true })
export class VerifyPhoneNumberPipe implements PipeTransform {
  transform(phoneNumber: string): string {
    return verifyPhoneNumber(phoneNumber);
  }
}
